import React from 'react'
import { Link } from 'react-router-dom'
import { Typography, Tabs, Row, Col, Input, Icon, Select, Spin, Modal, Button } from 'antd'
import { withApollo } from 'react-apollo'
import moment from 'moment/min/moment-with-locales';
import Container from '../../../../components/user/Container'
import ModalErrors from '../../../../components/user/ModalErrors'
import axios from 'axios';
import { UrlMeeting } from '../../../../utils/auth'
import { downloadFile } from '../../../../utils/downloadFile'
import iconDeclineRed from '../../../../assets/images/icons/icon-decline-red.png'
import iconInfoYellow from '../../../../assets/images/icons/icon-info-yellow.png'
import iconSummitGreen from '../../../../assets/images/icons/icon-summit-green.png'
import iconSwap from '../../../../assets/images/icons/icon-swap.png'
import axiosAPI from '../../../../config/axiosAPI';

const { TabPane } = Tabs;
class WaitMeetingForm extends React.Component {

    state = {
        idMeeting: null,
        statusAccept: "",
        fromPage: "/meetingmanagement/inviteMeeting",
        dataMeeting: [],
        GuestsInvite: [],
        OtherGuestsInvite: [],
        ApproverDetail: [],
        OrganizerDetail: [],
        preload: true,
        id: "",
        type: "",
        lastEditDate: "",
        isDelegate: false,
        delegateDetail: null,
        loadingScreen: false,
        remark: "",
        showModalInvitee: false,
    }


    componentDidMount = async () => {
        this.fetchDataMeeting();
    }
    fetchDataMeeting = async () => {
        this.setState({ loadingScreen: true });
        const queryString = require('query-string');
        const parsed = queryString.parse(this.props.location.search);
        if (parsed.id) await this.setState({ idMeeting: parsed.id })
        if (parsed.from) await this.setState({ fromPage: parsed.from })
        console.log("parsed.id", parsed.id);
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/meetingdetail`,
            {
                MeetingID: parsed.id
            })
            .then(response => {
                const data = response.data.status.message
                this.setState({
                    dataMeeting: data[0] ? data[0] : [],
                    ApproverDetail: data[1].ApproverDetail ? data[1].ApproverDetail : [],
                    OrganizerDetail: data[1].OrganizerDetail ? data[1].OrganizerDetail : [],
                    GuestsInvite: data[0].Guests ? data[0].Guests : [],
                    OtherGuestsInvite: data[0].OtherGuests ? data[0].OtherGuests : [],
                    lastEditDate: moment(data[0]?.updateDate).add(543, 'year').locale('th').format('DD MMMM YYYY HH:mm น.') || "",
                    preload: false,
                    loadingScreen: false,
                    remark: data[0]?.Remarks[0] ? data[0]?.Remarks[0].detail : ""
                })

                const found = (data[0].Guests).find(obj => {
                    return obj.userID === sessionStorage.getItem('username');
                });

                if (data[0].Guests && found.StatusResponse.statusName) {
                    this.setState({ statusAccept: found.StatusResponse.statusName });
                }

                const checkDelegate = (found?.Delegate !== null || found?.isDelegate)
                this.setState({ isDelegate: checkDelegate });

                if (found?.Delegate !== null) {
                    const findDelegate = data[0].Guests.find(o => o.userID == found.Delegate.userID)
                    this.setState({ delegateDetail: findDelegate });
                }

            }).catch(error => {
                this.setState({ loadingScreen: false, })
                console.error(`Error: ${error}`)
            })
    }

    getLengthAcceptInternal = (data) => {
        return data.filter(o => o.StatusResponse.statusName.toLowerCase() == "join").length
    }

    getLengthAcceptExternal = (data) => {
        return data.filter(o => o.asRole == "1").length
    }

    getLength = (arr) => {
        if (arr) {
            return arr.length;
        }
    }

    onCloseModalInvitee = () => {
        this.setState({ showModalInvitee: false })
    }

    selectIconPath = (status) => {
      switch (status) {
          case 'Waiting':
              return iconInfoYellow
          case 'Join':
              return iconSummitGreen
          case 'Refuse':
              return iconDeclineRed
          case 'Agent':
              return iconSwap
          case '1':
              return iconInfoYellow
          case '2':
              return iconSummitGreen
      }
  }

    render() {
        const { match } = this.props
        const { dataMeeting, ApproverDetail, OrganizerDetail, OtherGuestsInvite, GuestsInvite, preload, delegateDetail } = this.state
        const concatDelegateName = (delegateDetail?.title || "") + " " + (delegateDetail?.firstName || "") + " " + (delegateDetail?.lastName || "");
        const delegateFullName = concatDelegateName.trim() === "" ? "" : concatDelegateName
        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalConfirmErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                <Spin tip="Loading..." size="large" spinning={this.state.loadingScreen} style={{ alignItems: 'center', position: 'initial' }}>
                    <div className="card-container meeting-management" id="form-meeting">
                        <div className="card-bg-white">
                            <Row className="pt-4 pb-3 px-3" gutter={16} type="flex">
                                <Col xs={19} >
                                    <a href="javascript:history.back()">
                                        <Icon type="left" className="icon-back-meeting" /><p style={{ display: "inline", color: "#4D4D4D" }}> รายละเอียดการประชุม</p>
                                    </a>
                                </Col>
                                <Col xs={5} align={"right"} >
                                    {dataMeeting.isApproved == 0 ?
                                        <Link
                                            to={{
                                                pathname: `/meetingmanagement/createMeetingForm/`,
                                                search: 'approve=' + (dataMeeting.requireApprove ? "yes" : "no")
                                                    + '&note=' + (dataMeeting.requireMeetingSummary ? "yes" : "no")
                                                    + '&id=' + this.state.idMeeting
                                                    + '&from=/meetingmanagement/CreateMeeting'
                                                    + '&status=WaitingApprove',
                                            }}>
                                            <Icon type="form" style={{ fontSize: "20px", color: "#666666" }} />
                                        </Link>
                                        :
                                        <></>
                                    }
                                </Col>
                            </Row>
                            {
                                preload &&
                                <div className="pt-4 mt-3" style={{ textAlign: 'center', borderRadius: "10px", height: "130px" }}>
                                    <Icon type="loading" />
                                </div>
                                ||
                                <Row gutter={16} type="flex">
                                    <Col lg={{ span: 20, offset: 2 }} >
                                        <Row className="px-5 py-3 pb-5" gutter={16} type="flex" align="top">
                                            <Col xs={12}>
                                                <Icon type="user" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">ผู้เชิญประชุม</p><br />
                                                <p className="text-detail-meeting ml-2">{OrganizerDetail.title} {OrganizerDetail.firstName} {OrganizerDetail.lastName}</p>
                                            </Col>
                                            {ApproverDetail.length != 0 ?
                                                < Col xs={12}>
                                                    <Icon type="user" className="icon-fonttext-meeting" />
                                                    <p className="text-title-meeting ml-2 mb-0">ผู้อนุมัติการประชุม</p><br />
                                                    <p className="text-detail-meeting ml-2">{ApproverDetail.firstName} {ApproverDetail.lastName}</p>
                                                </Col>
                                                :
                                                <></>
                                            }
                                            <Col xs={24} className="pt-3">
                                                <Icon type="menu" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">หัวข้อการประชุม</p><br />
                                                <p className="text-detail-meeting ml-2">{dataMeeting.subject}</p>
                                            </Col>

                                            <Col xs={12} className="pt-3">
                                                <Icon type="clock-circle" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">กำหนดการ</p><br />
                                                <p className="text-detail-meeting ml-2">{moment(dataMeeting.startDate).locale('th').add(543, 'year').format('DD MMMM YYYY')} / {moment(dataMeeting.startDate).format('HH:mm')} - {moment(dataMeeting.endDate).format('HH:mm')} น.</p>
                                            </Col>
                                            <Col xs={12} className="pt-3">
                                                <Icon type="clock-circle" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0" style={{ display: 'inline' }}>วันที่ออกเอกสาร</p><br />
                                                <p className="text-detail-meeting ml-2" style={{ display: 'inline' }}>{dataMeeting.documentDate ? moment(dataMeeting.documentDate).locale('th').add(543, 'year').format('DD MMMM YYYY') : "-"}</p>
                                            </Col>

                                            <Col xs={24} className="pt-3">
                                                <Icon type="environment" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">สถานที่จัดการประชุม</p><br />
                                                <p className="text-detail-meeting ml-2">{dataMeeting.location}</p>
                                            </Col>

                                            <Col xs={24} className="pt-3">
                                                <Icon type="team" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">รายชื่อผู้ถูกเชิญ ({GuestsInvite.length + OtherGuestsInvite.length})</p>
                                                <span onClick={() => this.setState({ showModalInvitee: true })} style={{ color: '#3C8BE9', cursor: 'pointer' }}>{"  ดูเพิ่มเติม"}</span>
                                                <br />
                                            </Col>

                                            <Col xs={12} className="pt-3">
                                                <p className="text-title-meeting ml-2 pl-3">ผู้เข้าร่วมภายใน ({this.getLengthAcceptInternal(GuestsInvite)}/{GuestsInvite.length})</p><br />

                                                {
                                                    GuestsInvite.map((element, i) => {
                                                        if (i >= 5) {
                                                            return <></>
                                                        }
                                                        return (<p className="text-detail-meeting ml-2">{i + 1}. {element.title} {element.firstName} {element.lastName}<br /></p>)
                                                    }
                                                    )
                                                }
                                            </Col>
                                            <Col xs={12} className="pt-3">
                                                <p className="text-title-meeting ml-2 pl-3">ผู้เข้าร่วมภายนอก ({this.getLengthAcceptExternal(OtherGuestsInvite)}/{OtherGuestsInvite.length})</p><br />
                                                {
                                                    OtherGuestsInvite.map((element, i) => {
                                                        if (i >= 5) {
                                                            return <></>
                                                        }
                                                        return (<p className="text-detail-meeting ml-2">{i + 1}. {element.name}<br /></p>)
                                                    }
                                                    )
                                                }
                                            </Col>

                                            <Col xs={24} className="pt-3">
                                                <Icon type="menu" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">รายละเอียด</p><br />
                                                <p className="text-detail-meeting ml-2">{dataMeeting.detail}</p>
                                            </Col>

                                            <Col xs={24} className="pt-3">
                                                <Icon type="video-camera" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">ลิงค์การประชุม</p><br />
                                                <a href={dataMeeting.meetingURL} target='__blank' className="ml-3">{dataMeeting.meetingURL}</a>
                                            </Col>

                                            <Col xs={24} className="pt-3">
                                                <Icon type="paper-clip" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">ไฟล์แนบ</p><br />
                                                {
                                                    (
                                                        dataMeeting.Attacheds ? dataMeeting.Attacheds : []).map((file, i) =>
                                                            <Row>
                                                                <a className="ml-4" onClick={() => {
                                                                    downloadFile(`${UrlMeeting()}/meeting/file/${file.fileNameGen}`, file.fileName)
                                                                }}>{file.fileName}</a>
                                                            </Row>
                                                        )
                                                }
                                            </Col>

                                            {this.state.remark && (
                                                <Col xs={24} className="pt-3">
                                                    <Icon type="message" className="icon-fonttext-meeting" />
                                                    <p className="text-title-meeting ml-2 mb-0">เหตุผลที่ไม่อนุมัติ</p><br />
                                                    <p className="text-detail-meeting ml-2">{this.state.remark}</p>
                                                </Col>
                                            )}

                                            {delegateDetail && (<Col xs={24} className="pt-3">
                                                <Icon type="swap" className="icon-fonttext-meeting" />
                                                <p className="text-title-meeting ml-2 mb-0">ส่งตัวแทน</p><br />
                                                <p className="text-detail-meeting ml-2">{delegateFullName || ''}</p>
                                            </Col>)}

                                            <Col xs={24} style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <Col xs={24} sm={24} md={24} lg={14} xl={12}>
                                                    {this.state.lastEditDate && (
                                                        <Col xs={24} className="mt-5">
                                                            <p className="text-title-meeting mb-0">{"แก้ไขล่าสุด: " + this.state.lastEditDate}</p><br />
                                                        </Col>
                                                    )
                                                    }
                                                </Col>

                                                <Col xs={24} sm={24} md={24} lg={10} xl={12} className={"mt-5"} style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                    {dataMeeting.isApproved == 0 ?
                                                        <Col span={24} align="end">
                                                            <p className={"text-box-meeting"} style={{ color: "#FDB75D", fontSize: "24px" }}>
                                                                <Icon style={{ fontSize: "24px" }} className="pr-2" type="exclamation-circle" />รออนุมัติ</p>
                                                        </Col>
                                                        :
                                                        <></>
                                                    }
                                                    {dataMeeting.isApproved == 1 ?
                                                        <Col span={24} align="end">
                                                            <p className={"text-box-meeting"} style={{ color: "#178991", fontSize: "24px" }}>
                                                                <Icon style={{ fontSize: "24px" }} className="pr-2" type="check-circle" />อนุมัติ</p>
                                                        </Col>
                                                        :
                                                        <></>
                                                    }
                                                    {dataMeeting.isApproved == 2 ?
                                                        <Col span={24} align="end">
                                                            <p className={"text-box-meeting"} style={{ color: "#D94339", fontSize: "24px" }}>
                                                                <Icon style={{ fontSize: "24px" }} className="pr-2" type="close-circle" />ไม่อนุมัติ</p>
                                                        </Col>
                                                        :
                                                        <></>
                                                    }
                                                    {dataMeeting.isApproved == 3 ?
                                                        <Col span={24} align="end">
                                                            <p className={"text-box-meeting"} style={{ color: "#178991", fontSize: "24px" }}>
                                                                <Icon style={{ fontSize: "24px" }} className="pr-2" type="check-circle" />ขอแก้ไขและอนุมัติ</p>
                                                        </Col>
                                                        :
                                                        <></>
                                                    }
                                                </Col>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            }
                        </div>
                    </div >
                    <Modal
                        // maskClosable={false}
                        className={"meeting-invitee-modal"}
                        visible={this.state.showModalInvitee}
                        onCancel={this.onCloseModalInvitee}
                        closable={true}
                        title="รายชื่อผู้อนุมัติการประชุม "
                        footer={[
                            <Button
                                key="close"
                                className={"btn-modal-confirm"}
                                onClick={this.onCloseModalInvitee}
                            >
                                ปิด
                            </Button>
                        ]}
                    >
                        <div style={{ height: 400, width: 400, overflow: "auto", overflowX: "hidden" }}>
                            <Row gutter={16} className={"pt-0"}>
                                <Tabs defaultActiveKey="1" >
                                    <TabPane
                                        style={{ marginLeft: '2%' }}
                                        tab={`ผู้เข้าร่วมภายใน (${this.getLengthAcceptInternal(GuestsInvite)}/${this.getLength(GuestsInvite)})`} key="1">
                                        {GuestsInvite.map((element, i) => {
                                            return (
                                                <Row type='flex' align='middle' className='my-3'>
                                                    <Col xs={20}>
                                                        <span className="text-detail-meeting">{element.title} {element.firstName} {element.lastName}</span>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <img src={this.selectIconPath(element.StatusResponse.statusName)} style={{ maxWidth: '20px', height: 'auto' }} />
                                                    </Col>
                                                </Row>
                                            )
                                        })}
                                    </TabPane>
                                    <TabPane
                                        tab={`ผู้เข้าร่วมภายนอก (${this.getLengthAcceptExternal(OtherGuestsInvite)}/${this.getLength(OtherGuestsInvite)})`} key="2">
                                        {OtherGuestsInvite.map((element, i) => {
                                           console.log("element", element)
                                            return (
                                                <Row type='flex' align='middle' className='my-3'>
                                                    <Col xs={20}>
                                                        <span className="text-detail-meeting">{element.name}</span>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <img src={this.selectIconPath(element.asRole)} style={{ maxWidth: '20px', height: 'auto' }} />
                                                    </Col>
                                                </Row>
                                            )
                                        })}
                                    </TabPane>
                                </Tabs>
                            </Row>
                        </div>
                    </Modal>
                </Spin>
            </Container >
        )
    }
}

WaitMeetingForm.propTypes = {
    //
}

export default withApollo(WaitMeetingForm)